module.exports = __webpack_public_path__ + "img/sch.2d663012.svg";